import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAuth} from "../../AuthContext";
import {useNotifications} from "../../components/NotificationSystem";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {resetPassword, clearError} = useAuth();
  const {addNotification} = useNotifications();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    setIsLoading(true);

    try {
      await resetPassword(email);
      setIsSubmitted(true);
      addNotification({
        type: "success",
        title: "Reset Link Sent",
        message: `Password reset link has been sent to ${email}. Please check your email and spam folder.`,
        duration: 8000,
      });
    } catch (error: any) {
      // Use notification system for error display
      addNotification({
        type: "error",
        title: "Reset Failed",
        message:
          error.message ||
          "An error occurred while sending the reset link. Please try again.",
        duration: 6000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  if (isSubmitted) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <h1>Check Your Email</h1>
          <p>
            We've sent a password reset link to <strong>{email}</strong>
          </p>
          <p>
            Please check your email and click the link to reset your password.
            If you don't see the email, check your spam folder.
          </p>
          <div className="auth-actions">
            <Link to="/auth/login" className="btn btn-primary">
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>Reset Password</h1>
        <p>
          Enter your email address and we'll send you a link to reset your
          password
        </p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading || !email}
          >
            {isLoading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="auth-link">
          Remember your password? <Link to="/auth/login">Sign in here</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
